import React from "react";
import { CGE } from "../../../../common/components/CGE";
import Loading from "../../../../common/components/Loading";
import { getPageLayoutType, decode_utf8 } from "../../../../common/utils/utilsFunc";
import { ClayRadio, ClayRadioGroup } from "@clayui/form";
import NextStepComercial from "../NextStepComercial"
import NextStepInterrupcion from "../NextStepInterrupcion";
import ConsultStateClaimContextProvider, {
    ConsultStateClaimContext,
    ACTIONS
} from "../../context/ConsultStateClaimContextProvider";
import { TOKEN_CAPTCHA_COOKIE_KEY } from "../../../../common/utils/cookiesUtil";
import useCookie from '../../../../common/hooks/useCookie';

const ConsultStateClaim = ({ props }) => {
    const [state, dispatch] = React.useContext(ConsultStateClaimContext);
    const [valueRadio, setValueRadio] = React.useState("0");
    const [numClaim, setNumClaim] = React.useState();
    const [nextStep, setNextStep] = React.useState(false);
    const [loading, setLoading] = React.useState(false);
    const [error, setError] = React.useState(false);
    const [verifReCaptcha, setVerifReCaptcha] = React.useState(false);
    const [showBtn, setShowBtn] = React.useState(false);
    const [inputDateAdimission, setInputDateAdimission] = React.useState("");
    const [inputCondition, setInputCondition] = React.useState("");
    const [inputClaim, setInputClaim] = React.useState("");
    const [inputFailureReason, setInputFailureReason] = React.useState("");
    const [inputDataTimeReplacement, setInputDataTimeReplacement] = React.useState();
    const { updateCookieState } = useCookie(TOKEN_CAPTCHA_COOKIE_KEY);
    
    function verifNextStep() {

        if (!valueRadio) {
            props.setGlobalAlert("Debes ingresar Comercial o Interrupción del Servicio Eléctrico", "warning");
        } else if (!numClaim) {
            setError(true)
            props.setGlobalAlert("Complete todos los campos obligatorios", "warning");

        } else if (!verifReCaptcha && !getPageLayoutType()) {
            props.setGlobalAlert("Falta validar que no eres un Robot", "warning");
        } else {
            setError(false)
            setLoading(true);
            dispatch({
                payload: { numClaim: numClaim, valueRadio: valueRadio, isSignedIn: getPageLayoutType() },
                type: ACTIONS.SET_SERV1,
            });
        }
    }
    React.useEffect(() => {
        setNumClaim('');
    }, [valueRadio]);

    React.useEffect(() => {
        setLoading(false);
        cleanErrors();
        const objResponse = state.response_serv1;

        if (objResponse) {
            if (objResponse?.code >= 0) {
                if (objResponse.code === 0) {
                    if (Number(valueRadio) !== 0) {
                        setInputDateAdimission(objResponse.fechaReclamo);
                        setInputCondition(objResponse.estado);
                        setInputClaim(objResponse.tipoReclamo);
                        setInputFailureReason(objResponse.motivo);
                        setInputDataTimeReplacement(objResponse.fechaHoraReposicion);

                        if (objResponse.estado === "Resuelto") {
                            setShowBtn(true);
                        } else {
                            setShowBtn(false);
                        }

                    } else {
                        setInputDateAdimission(objResponse.fecha);
                        setInputCondition(objResponse.status);

                        if (objResponse.status === "Resuelto") {
                            setShowBtn(true);
                        } else {
                            setShowBtn(false);
                        }
                    }

                    setNextStep(true);
                } else {
                    props.setGlobalAlert(objResponse.mensaje ? objResponse.mensaje : "Error al intentar consultar el estado del reclamo comercial", "warning", true, "Advertencia");

                }
            } else {
                props.setGlobalAlert("Error al intentar consultar el estado del reclamo comercial", "warning", true, "Advertencia");
            }
        }

    }, [state.response_serv1]);

    function onChangeReCaptcha(value) {
        updateCookieState(value);
        if (value) {
            setVerifReCaptcha(true);
            setError(false);
        }
        else {
            setVerifReCaptcha(false);
        }
    }

    function getCard() {
        setLoading(true);
        dispatch({
            payload: { numClaim: numClaim},
            type: ACTIONS.SET_SERV2,
        });
    }

    React.useEffect(() => {
        setLoading(false);
        cleanErrors();
        const objResponse = state.response_serv2;

        if (objResponse) {
            if (objResponse?.status === 500) {
                props.setGlobalAlert(objResponse?.message ? objResponse?.message : decode_utf8(props.text_fetch_error), "warning", true, "Advertencia");

            } else if (objResponse?.status === 999) {
                props.setGlobalAlert(objResponse?.message ? objResponse?.message : "¡Por favor, no cierres la pestaña que se abrió!", "warning", true, "Advertencia");

            }
        }
    }, [state.response_serv2])

    function handleClick(text) {
        alert(text);
    }

    const objNextStepComercial = {
        'setInputDateAdimission': setInputDateAdimission,
        'inputDateAdimission': inputDateAdimission,
        'setInputCondition': setInputCondition,
        'inputCondition': inputCondition,
        'funcClick': handleClick
    };

    const objNextStepInterrupcion = {
        'setInputDateAdimission': setInputDateAdimission,
        'inputDateAdimission': inputDateAdimission,
        'setInputClaim': setInputClaim,
        'inputClaim': inputClaim,
        'setInputCondition': setInputCondition,
        'inputCondition': inputCondition,
        'setInputFailureReason': setInputFailureReason,
        'inputFailureReason': inputFailureReason,
        'setInputDataTimeReplacement': setInputDataTimeReplacement,
        'inputDataTimeReplacement': inputDataTimeReplacement,

    };

    function cleanErrors() {
        setError(false);
    }

    function cleanAll() {
        cleanErrors();
        setNextStep(false);
        setShowBtn(false);
        setInputCondition("");
        setInputDateAdimission("");
    }

    return (
        <CGE.Panel title={props.title_page_consulta_de_estado_de_reclamo} >
            <CGE.PanelContainer
                alingItensCenter={true}
                size="md"
            >
                <div className="resp-forms-recaptcha" >
                    {!window?.location?.host?.includes("edelmag") ?
                        <ClayRadioGroup
                            className="ClayRadioGrup"
                            inline
                            onSelectedValueChange={(value) => {
                                setValueRadio(value);
                                cleanAll();
                            }}
                            selectedValue={valueRadio}
                        >
                            <ClayRadio className="mr-2" label="Comercial" value="0" />
                            <ClayRadio label="Interrupción del Servicio Eléctrico" value="1" />
                            <div className="cge-radio-mobile">

                            </div>
                        </ClayRadioGroup>
                        :
                        <ClayRadioGroup
                            className="ClayRadioGrup"
                            inline
                            onSelectedValueChange={(value) => {
                                setValueRadio(value);
                                cleanAll();
                            }}
                            selectedValue={valueRadio}
                        >
                            <ClayRadio label="Comercial" value="0" />
                        </ClayRadioGroup>
                    }
                    <div className="margin-state-claim">
                        <CGE.FormsField
                            horizontal={true}
                            labelName="Número de Reclamo"
                            handleChange={({ target }) => {
                                let num = target.value;
                                const maxLength = parseInt(valueRadio) === 0 ? 8 : 14;
                                if (num.length > maxLength) {
                                num = num.slice(0, maxLength);
                                  }
                                setNumClaim(target.value);
                                cleanAll();
                            }}
                            idFormElement="numClaim"
                            typeFormElement="text"
                            mandatoryElement={true}
                            typeElement="input-mask"
                            hasError={error && !numClaim && valueRadio}
                            value={numClaim}
                            msgError="Debes ingresar un Nro. de Reclamo"
                            maxLength={parseInt(valueRadio) === 0 ? 8 : 14}
                            formatChars={parseInt(valueRadio) === 0 ? { 9: "[0-9]" } : undefined}
                            mask={parseInt(valueRadio) === 0 ? "99999999" : "9999-99-999999"}
                        />
                    </div>
                    {!getPageLayoutType() &&
                        <>
                            <CGE.FieldRecaptcha
                                horizontal={true}
                                onChange={onChangeReCaptcha}
                                sitekey={props.api_key_recaptcha}
                            />
                        </>
                    }
                    <div className="d-flex justify-content-center" >
                        <CGE.Button
                            label="Buscar"
                            onClick={() => { verifNextStep() }}
                        />
                    </div>
                </div>

                {nextStep && <CGE.Spacing type="nl" />}

                {nextStep && valueRadio === "0" && (
                    <NextStepComercial props={objNextStepComercial} />
                )}
                {nextStep && valueRadio === "1" && (
                    <NextStepInterrupcion props={objNextStepInterrupcion} />
                )}

                {showBtn &&
                    <div className="d-flex justify-content-center" >
                        <CGE.Button
                            label="Ver Carta Respuesta"
                            type="ghost"
                            onClick={() => { getCard() }}
                        />
                    </div>
                }
            </CGE.PanelContainer>
            {loading && <Loading />}
        </CGE.Panel>
    );
};

const ConsultStateClaimWithProvider = ({ props }) => (
    <ConsultStateClaimContextProvider>
        <ConsultStateClaim props={props} />
    </ConsultStateClaimContextProvider>
);
export default ConsultStateClaimWithProvider;
